module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "title": 'Request to ' + this.heading,
      "id": this.type.toLowerCase() + '-action-table',
      "table-ref": this.type.toLowerCase() + '-action-table',
      "url": '/view/actions/' + (this.telcoId ? this.type + '/' + this.telcoId : this.type + '/null') + '/' + _vm.reqStatus,
      "fields": _vm.fields,
      "detail-component": "request-details",
      "sort-field": _vm.sortFields,
      "sort-direction": "DESC",
      "search-placeholder": "Site Names, Site IDs, Status, Timeline...",
      "show-refresh": true,
      "showSearch": true,
      "bottom-comp": _vm.bComp,
      "bottom-comp-props": _vm.bCompProps,
      "hide-org-badge": _vm.isTowerCo(),
      "add-action": (_vm.isBackhaulCo() || _vm.isTelco() || _vm.isManager('management|project|admin')) ? _vm.addAction : null,
      "add-props": _vm.addProps
    },
    scopedSlots: _vm._u([{
      key: "request-details",
      fn: function(props) {
        return [_c('el-row', {
          class: _vm.formatBG(props.rowData.actionType),
          staticStyle: {
            "padding": "0.852em"
          },
          attrs: {
            "gutter": 8.52
          }
        }, [_c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 24,
            "lg": 12
          }
        }, [_c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('h3', {
          class: _vm.formatRequest(props.rowData.actionType)
        }, [(!_vm.isTelco()) ? _c('org-badge', {
          attrs: {
            "short-name": props.rowData.shortName,
            "color": props.rowData.colourCode
          }
        }) : _vm._e(), _vm._v(" "), (props.rowData.actionType === 'RTB' && props.rowData.provider_id) ? _c('div', {
          staticClass: "pull-right"
        }, [_c('h5', [_vm._v("Provider: "), _c('org-badge', {
          attrs: {
            "short-name": props.rowData.providerShortName,
            "color": props.rowData.providerColourCode
          }
        }), _vm._v(" "), _c('b', {
          staticClass: "text-black"
        }, [_vm._v(_vm._s(props.rowData.backhaulType))])], 1)]) : _vm._e()], 1), _vm._v(" "), _c('h4', {
          class: _vm.formatRequest(props.rowData.actionType)
        }, [((props.rowData.status === 'Rejected' || props.rowData.status === 'Closed')) ? _c('span', [_c('b', {
          class: (props.rowData.status === 'Rejected' ? 'text-warning' : 'text-success')
        }, [_vm._v(_vm._s(props.rowData.status))]), _vm._v("\n                   | ")]) : _vm._e(), _c('b', [(props.rowData.status === 'NEW' || props.rowData.status === 'Pending') ? _c('el-badge', {
          attrs: {
            "value": props.rowData.status,
            "type": props.rowData.status === 'Pending' ? 'warning' : 'danger'
          }
        }, [_vm._v("\n                      " + _vm._s(props.rowData.siteName) + "\n                    ")]) : _c('span', [_vm._v(_vm._s(props.rowData.siteName))])], 1), _vm._v(" "), (props.rowData.telcoSiteId) ? _c('span', [_vm._v(" (" + _vm._s(props.rowData.telcoSiteId) + ")")]) : _vm._e()]), _vm._v(" "), _c('el-steps', {
          staticClass: "hidden-sm-and-down",
          attrs: {
            "active": props.rowData.currentStep - 1,
            "finish-status": _vm.formatStep(props.rowData.actionType),
            "align-center": "",
            "direction": "horizontal"
          }
        }, _vm._l((props.rowData.stepWorkflow), function(s) {
          return _c('el-step', {
            key: s.stepName,
            attrs: {
              "description": s.stepName
            }
          }, [_c('template', {
            slot: "icon"
          }, [_c('i', {
            class: s.stepIcon,
            staticStyle: {
              "background": "inherit"
            }
          })])], 2)
        }), 1)], 1), _vm._v(" "), _c('el-col', {
          staticStyle: {
            "padding-top": "7.41px"
          },
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 24,
            "lg": 24,
            "align": "left"
          }
        }, [_c('el-row', {
          attrs: {
            "gutter": 5.28
          }
        }, [_c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 24,
            "lg": 14,
            "align": "left"
          }
        }, [(props.rowData.currentStep >= 0 && props.rowData.totalSteps) ? _c('el-progress', {
          attrs: {
            "stroke-width": 26,
            "percentage": (props.rowData.currentStep / props.rowData.totalSteps * 100),
            "color": _vm.progessBar(props.rowData.actionType),
            "text-inside": true
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 24,
            "lg": 10,
            "align": props.rowData.totalSteps ? 'center' : 'left'
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatPeriod(props.rowData.Period))
          }
        }), _vm._v(" | \n                " + _vm._s((props.rowData.Period === 'Finished' ? '' : 'Due:')) + "\n                " + _vm._s(_vm.formatDate((props.rowData.Period === 'Finished' ? props.rowData.actualDate : props.rowData.targetDate))) + "\n                 | \n                "), _c('b', [_vm._v(_vm._s(_vm.formatFriendlyDate((props.rowData.Period === 'Finished' ? props.rowData.actualDate : props.rowData.targetDate))))])]), _vm._v(" "), (_vm.isDesktop && _vm.isTowerCo()) ? _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('br'), _vm._v(" "), _c('h5', [_vm._v("Client: "), _c('b', [_vm._v(_vm._s(props.rowData.name))])])]) : _vm._e()], 1), _vm._v(" "), _c('small', [_vm._v("Ref: "), _c('i', [_vm._v(_vm._s(props.rowData.siteId) + "-" + _vm._s(props.rowData.id))])])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "xs": 24,
            "sm": 24,
            "md": 24,
            "lg": 12
          }
        }, [_c('site-card', {
          attrs: {
            "site-data": props.rowData,
            "use-leaflet": "",
            "hide-site": "",
            "height": "230px"
          }
        })], 1)], 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-006c0131"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/RequestTable.vue
// module id = 1382
// module chunks = 0